// extracted by mini-css-extract-plugin
module.exports = {"rtl-mode":"ModalVideo_rtl-mode__3ZPgy","rtl-mirror":"ModalVideo_rtl-mirror__Z3oRr","playerWrapper":"ModalVideo_playerWrapper__23DLz","iconClose":"ModalVideo_iconClose__2Mz8k"};